import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AppFooter } from '@teliaee/telia-megamenu';
import config from '../Config';
import ContentStore from '../stores/ContentStore';
import FooterStore from '../stores/FooterStore';
import LanguageStore from '../stores/LanguageStore';
import RouteStore from '../stores/RouteStore';
import { TranslationsContext } from '@teliaee/telia-translate';

export interface PublicFooterProps {
  isNode?: boolean;
  languageStore?: LanguageStore;
  routeStore?: RouteStore;
  footerStore?: FooterStore;
  contentStore?: ContentStore;
  isMyTeliaUserAgent?: boolean;
}

@observer
class PublicFooter extends React.Component<PublicFooterProps> {
  static contextType = TranslationsContext;
  declare context: React.ContextType<typeof TranslationsContext>;
  private get lang() {
    return this.props.languageStore.currentLanguage;
  }

  private get tier() {
    return config.componentTier || 'live';
  }

  private get isSsr() {
    return this.props.isNode;
  }

  private get columns() {
    return this.props.footerStore.columns;
  }

  private get hideFooter() {
    return this.props.isMyTeliaUserAgent || this.props.contentStore.currentPageContent.hideFooter;
  }

  private handleNavigation = (path: React.MouseEvent<HTMLElement>) => {
    this.props.routeStore.navigate(path);
  };

  public render(): JSX.Element {
    if (this.hideFooter) {
      return null;
    }

    return (
      <AppFooter
        app="public"
        tier={this.tier}
        lang={this.lang}
        translations={this.context.translations || {}}
        columns={this.columns}
        onPathChange={this.handleNavigation}
        isSSR={this.isSsr}
      />
    );
  }
}

export default inject('isNode', 'languageStore', 'routeStore', 'footerStore', 'contentStore')(PublicFooter);
